module.exports = __webpack_public_path__ + "assets/img/chef-6.2bd04984.jpg";